/// *** System import ***///
import { Injectable, Inject } from '@angular/core';
import { Events, ToastController } from 'ionic-angular';
import { Http, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import { hubConnection } from 'signalr-no-jquery';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
/// *** Custom import ***///
import { Globals } from '../../app/globals';
import { EnvVariables } from '../../app/environment-variables/environment-variables.token';

@Injectable()
export class MainHubProvider {
  constructor(
    // *** System
    private events: Events,
    private http: Http,
    private toastCtrl: ToastController,
    // *** Custom
    private globals: Globals,
    @Inject(EnvVariables) private envVariables) {
  }

  // *** Hub subscription
  public subscribe(userID: string) {
    return new Promise((resolve, reject) => {
      try {
        // Init
        let connection = hubConnection(this.envVariables.mainPushEndpoint);
        connection.logging = false;
        let proxy = connection.createHubProxy('webmain');
        // Subscriptions
        proxy.on('notify', this._onNotify(this));
        proxy.on('updateTradingSessionStatus', this._onUpdateTradingSessionStatus(this));
        proxy.on('updateSecurityGroupState', this._onUpdateSecurityGroupState(this));
        proxy.on('updateTime', this._onUpdateTime(this));
        proxy.on('disconnect', this._onDisconnect(this));
        // Start
        connection.start()
          .done(function () {
            proxy.invoke('subscribe', userID);
          })
          .fail(function () {
            this.events.publish('MainHubProvider.reconnect', userID);
          });
        // Keep alive
        connection.disconnected(function () {
        });
        // On try reconnect
        this.events.subscribe('MainHubProvider.reconnect',
          (userID) => {
            connection.stop();
            setTimeout((provider = this) => {
              provider.subscribe(userID);
            }, 5000);
          });
        // On hub abord
        this.events.subscribe('MainHubProvider.abord', () => { connection.stop(); });
        // On session user logout
        this.events.subscribe('SessionProvider.logout', () => { connection.stop(); });
        resolve();
      }
      catch (error) {
        this.globals.showCommunicationError(this.toastCtrl, error);
        reject();
      }
    });
  }

  // *** 'notify' handler
  private _onNotify(provider: MainHubProvider): { (notificationID: number, count: number, approvalCount: number): void } {
    return function (notificationID: number, count: number, approvalCount: number) {
      provider.events.publish('MainHubProvider.notify', notificationID, count, approvalCount);
    }
  }

  // *** 'updateTradingSessionStatus' handler
  private _onUpdateTradingSessionStatus(provider: MainHubProvider): { (status: string): void } {
    return function (status: string) {
      provider.events.publish('MainHubProvider.updateTradingSessionStatus', status);
    }
  }

  // *** 'updateSecurityGroupState' handler
  private _onUpdateSecurityGroupState(provider: MainHubProvider): { (securityGroupTooltip: string): void } {
    return function (securityGroupTooltip: string) {
      provider.events.publish('MainHubProvider.updateSecurityGroupState', securityGroupTooltip);
    }
  }

  // *** 'updateTime' handler
  private _onUpdateTime(provider: MainHubProvider): { (time: any): void } {
    return function (time: any) {
      provider.events.publish('MainHubProvider.updateTime', time);
    }
  }

  // *** 'disconnect' handler
  private _onDisconnect(provider: MainHubProvider): { (): void } {
    return function () {
      provider.events.publish('MainHubProvider.disconnect');
    }
  }
}


// WEBPACK FOOTER //
// ./src/providers/serverHubs/main.ts